export const memberHomeEn = {
    shishizhibiao:"Real-time index",
    jiancherenzhenfuwu:"Testing and certification service",
    shenghe:'In audit',
    zhixunbaojia:'Consulting quotation',
    peixunfuwu:'Training service',
    zhuanjiazhixun:'Expert consultation',
    weiwangchengdingdang:'Unfinished order',
    more:'View more',
    dingdangxiangqing:'Order details',
    dingdanghao:'Order number',
    riqi:'date',
    zhuantai:'state',
    caozuo:'operation',
    zuijinlioulanfuwu:'Recent browsing service',
    zuijinshoucangfuwu:'Recent collection services'
}


// WEBPACK FOOTER //
// ./src/lang/member/memberHome/memberHomeEn.js